import type { CSSProperties } from "react";

const TRANSITION =
  "transition-[rotate,translate] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none";

type ThumbSlot = {
  name: string;
  gameIndex: number;
  geometry: CSSProperties;
  className: string;
};

const THUMB_SLOTS: ThumbSlot[] = [
  {
    name: "left",
    gameIndex: 1,
    geometry: {
      left: "6.61%",
      top: "10.79%",
      width: "42.18%",
      height: "82.53%",
    },
    className: `-rotate-15 group-hover:-rotate-25 group-hover:-translate-y-[4.84%] ${TRANSITION}`,
  },
  {
    name: "right",
    gameIndex: 2,
    geometry: {
      left: "51.19%",
      top: "10.85%",
      width: "42.18%",
      height: "82.53%",
    },
    className: `rotate-15 group-hover:rotate-25 group-hover:-translate-y-[4.84%] ${TRANSITION}`,
  },
  {
    name: "center",
    gameIndex: 0,
    geometry: { left: "28.05%", top: "0%", width: "43.98%", height: "86.05%" },
    className: `shadow-[0_0_20px_11px_rgba(21,24,27,0.48)] group-hover:-translate-y-[11.14%] ${TRANSITION}`,
  },
];

export default THUMB_SLOTS;
